module.exports = "<mat-icon matTooltip=\"Export\" (click)=\"exportData()\">file_download</mat-icon>\r\n"